import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useProgramPanel } from 'contexts/programPanelContext';
import { ProgramStatus } from 'components/programPanel/programDashboard/dashboard/panels/status';
import { ProgramProcessSummaries } from 'components/programPanel/programDashboard/dashboard/panels/process-summaries';

export const CoordinatorProgramDashboard = () => {
	const { t } = useTranslation();

	const { refetch, isStale, data } = useProgramPanel();

	useEffect(() => {
		if (isStale) {
			refetch?.();
		}
	}, []);

	return !data ? null : (
		<>
			<Helmet title={t('organizationPanel.programDashboard')} />
			<div className="flex flex-column">
				<ProgramStatus programData={data} readOnly />
				<ProgramProcessSummaries programData={data} readOnly />
			</div>
		</>
	);
};
